// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"78":"29f31d23","338":"8fbe1f97","544":"6ca6bdaa","576":"49515404","753":"0bed8a85","775":"5e8007e7","823":"9b84d418","990":"e485c905"}[chunkId] + ".js";
};